<template>
  <div></div>
</template>


<script>
export default {
  template: "PageNotFound",
  created: function () {
    // Redirect outside the app using plain old javascript
    window.location.href = "/";
  },
};
</script>